import React, { useState, useEffect, useCallback } from 'react';
import './TearFaceIcon.css';

function TearFaceIcon() {
  const [tearPosition, setTearPosition] = useState(0);
  const [faceOpacity, setFaceOpacity] = useState(1);

  const handleScroll = useCallback(() => {
    const scrollY = window.scrollY;
    const vh = window.innerHeight;
    const docH = document.documentElement.scrollHeight;
    const maxScroll = docH - vh;
    
    // Calculate positions with smooth constraints
    const scrollRatio = Math.min(scrollY / maxScroll, 1);
    const newTearPosition = Math.min(scrollRatio * (vh - 100), vh - 100);
    const newFaceOpacity = Math.max(0, 1 - (scrollY / 200));

    setTearPosition(newTearPosition);
    setFaceOpacity(newFaceOpacity);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  const handleTearClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="tear-face-container">
      <img
        src="/images/FacewoT.png"
        alt="Face without Tear"
        className="face"
        style={{ opacity: faceOpacity }}
      />
      <img
        src="/images/tear.png"
        alt="Tear"
        className="tear"
        style={{ transform: `translateY(${tearPosition}px)` }}
        onClick={handleTearClick}
      />
    </div>
  );
}

export default TearFaceIcon;